
export default {
  name: "IconChevronLeft",
};
